import { IFilter } from '@root/modules/Sellers/Product/interfaces';

import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Col, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import busksellerdetail from '../services/busksellerdetail';

countries.registerLocale(enLocale);

export enum IntergrationType {
  SHOPEE = 1,
  LAZADA = 2,
  AMAZONE = 3
}

interface IWarehouse {
  name: string;
}

export const COLUMNS = [
  {
    title: 'No',
    dataIndex: 'no',
    key: 'no'
  },
  {
    title: '국가',
    dataIndex: 'countryCode',
    key: 'countryCode', //VN, KR, JP, TH, ID
    render: (countryCode: string) => countries.getName(countryCode, 'en')
  },
  {
    title: '마켓플레이스', //marketplace
    dataIndex: 'type',
    key: 'type',
    render: (type: IntergrationType) => {
      switch (type) {
        case IntergrationType.SHOPEE:
          return 'Shopee';
        case IntergrationType.LAZADA:
          return 'Lazada';
        case IntergrationType.AMAZONE:
          return 'Amazon';
        default:
          return '-';
      }
    }
  },
  {
    title: '창고',
    dataIndex: 'warehouse',
    key: 'warehouse',
    render: (warehouse: IWarehouse) => {
      return warehouse.name || '-';
    }
  },
  {
    title: '연동 현황', //status
    dataIndex: 'status',
    key: 'status',
    render: (status: number) => {
      return status === 1 ? '연동중' : '연동 해제';
    }
  },
  {
    title: '연동 시작일', //start intergration date
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: '연동 해제일', //end intergration date
    dataIndex: 'disconnectDate',
    key: 'disconnectDate',
    render: (disconnectDate: string, { status, shopId }: any) => {
      if (status === 1) {
        return (
          <Button href={`https://seller.shopee.kr/portal/sale/order?cnsc_shop_id=${shopId}`}>
            해제하기
          </Button>
        );
      }
      return disconnectDate || '-';
    }
  }
];

const IntergrationHistory = () => {
  const { id } = useParams<{ id: string }>();

  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState<React.Key[]>([]);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState();
  const [totalRows, setTotalRows] = useState(0);

  const filter: IFilter = {};

  const getList = async () => {
    setLoading(true);

    const result = await busksellerdetail.getIntergrationHistory({
      page,
      limit: 10,
      filter,
      id: Number(id)
    });

    const data = result.data?.map((item: any) => {
      return {
        ...item,
        key: item.id,
        no: item.id,
        created_at: formatDateTime(item.created_at),
        disconnectDate: formatDateTime(item.disconnectDate)
      };
    });

    setRows(data);
    setTotalRows(result?.meta?.totalItems ?? 0);
    setLoading(false);
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'REFRESH_INTERGRATION_HISTORY') {
        getList();
      }
    };

    window.addEventListener('message', handleMessage);
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    getList();
  }, [page]);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedIds(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedIds,
    onChange: onSelectChange
  };

  return (
    <>
      <div className="busk-sellerSubHead">
        <Row align="middle">
          <Col flex="auto">
            <Typography.Text>총 내역 {totalRows}</Typography.Text>
          </Col>
        </Row>
      </div>
      <Table
        className="busk-table"
        rowSelection={rowSelection}
        pagination={{
          pageSize: 10,
          total: totalRows,
          onChange: (newPage) => {
            setPage(newPage);
          }
        }}
        loading={loading}
        columns={COLUMNS}
        dataSource={rows}
      />
    </>
  );
};

export default IntergrationHistory;
